import { AppTheme } from '@backstage/core-plugin-api';
import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import './herodevs.css';
import { herodevsDarkTheme, herodevsLightTheme } from './herodevsTheme';

// The ids match Backstage's built-in themes, so a saved light or dark
// preference carries over. The theme name scopes herodevs.css.
export const themes: AppTheme[] = [
  {
    id: 'light',
    title: 'Light',
    variant: 'light',
    icon: <LightIcon />,
    Provider: ({ children }) => (
      <UnifiedThemeProvider theme={herodevsLightTheme} themeName="herodevs">
        {children}
      </UnifiedThemeProvider>
    ),
  },
  {
    id: 'dark',
    title: 'Dark',
    variant: 'dark',
    icon: <DarkIcon />,
    Provider: ({ children }) => (
      <UnifiedThemeProvider theme={herodevsDarkTheme} themeName="herodevs">
        {children}
      </UnifiedThemeProvider>
    ),
  },
];
